// import React, { useState, useEffect } from 'react';
// import {
//     Container,
//     Card,
//     Button,
//     Form,
//     Row,
//     Col,
//     Spinner,
//     Nav,
//     Modal,
// } from 'react-bootstrap';
// import {
//     FaSave,
//     FaBuilding,
//     FaMapMarkerAlt,
//     FaPlug,
//     FaLock,
//     FaCrown,
//     FaRocket,
//     FaFileSignature,
// } from 'react-icons/fa';
// import { toast } from 'react-toastify';
// import { Link, useNavigate } from 'react-router-dom';
// import api from '../../services/api';
// import { usePlanAccess } from '../../hooks/usePlanAccess';

// // ── Tipos ──────────────────────────────────────────────
// type CompanyStatus = 'ACTIVE' | 'SUSPENDED' | 'CANCELED';
// type ActiveGateway = 'lytex' | 'asaas' | '';
// type FeatureKey = 'boleto' | 'contrato' | 'whatsapp' | 'nfe';

// interface CompanyFormData {
//     id: string;
//     name: string;
//     corporateName: string;
//     cnpj: string;
//     email: string;
//     phone: string;
//     municipalRegistration: string;
//     stateRegistration: string;
//     taxRegime: string;
//     zipCode: string;
//     street: string;
//     number: string;
//     complement: string;
//     neighborhood: string;
//     city: string;
//     state: string;
//     activeGateway: ActiveGateway;
//     asaasApiKey: string;
//     asaasWebhookSecret: string;
//     lytexClientId: string;
//     lytexClientSecret: string;
//     lytexWebhookSecret: string;
//     autentiqueApiToken: string;
//     teamzapUrl: string;
//     teamzapToken: string;
//     status: CompanyStatus;
// }

// interface InvoiceSettingsData {
//     invoiceEnabled: boolean;
//     invoiceDefaultForNew: boolean;
// }

// interface ViaCepResponse {
//     logradouro: string;
//     bairro: string;
//     localidade: string;
//     uf: string;
//     erro?: boolean;
// }

// // ── Constantes ─────────────────────────────────────────
// const STATUS_COLORS: Record<CompanyStatus, string> = {
//     ACTIVE: 'success',
//     SUSPENDED: 'warning',
//     CANCELED: 'danger',
// };

// const STATUS_LABELS: Record<CompanyStatus, string> = {
//     ACTIVE: 'Ativa',
//     SUSPENDED: 'Suspensa',
//     CANCELED: 'Cancelada',
// };

// const PLAN_LABELS: Record<string, string> = {
//     BASIC: 'Básico',
//     PRO: 'Profissional',
//     ENTERPRISE: 'Empresarial',
// };

// const PLAN_COLORS: Record<string, string> = {
//     BASIC: '#6c757d',
//     PRO: '#4361ee',
//     ENTERPRISE: '#f8961e',
// };

// const PLAN_ICONS: Record<string, React.ReactNode> = {
//     BASIC: <FaLock size={12} />,
//     PRO: <FaRocket size={12} />,
//     ENTERPRISE: <FaCrown size={12} />,
// };

// const FEATURES: Record<FeatureKey, { label: string; description: string; requiredPlan: string }> = {
//     boleto: {
//         label: 'Gateway de Pagamento',
//         description: 'Gere cobranças via PIX, Boleto e Cartão automaticamente.',
//         requiredPlan: 'PRO',
//     },
//     contrato: {
//         label: 'Assinatura Digital de Contratos',
//         description: 'Envie contratos para assinatura digital via Autentique.',
//         requiredPlan: 'ENTERPRISE',
//     },
//     whatsapp: {
//         label: 'Notificações WhatsApp',
//         description: 'Dispare mensagens automáticas de cobrança via WhatsApp.',
//         requiredPlan: 'PRO',
//     },
//     nfe: {
//         label: 'Emissão de Notas Fiscais',
//         description: 'Emita NFS-e automaticamente após o pagamento das parcelas.',
//         requiredPlan: 'PRO',
//     },
// };

// const INITIAL_FORM: CompanyFormData = {
//     id: '',
//     name: '',
//     corporateName: '',
//     cnpj: '',
//     email: '',
//     phone: '',
//     municipalRegistration: '',
//     stateRegistration: '',
//     taxRegime: '',
//     zipCode: '',
//     street: '',
//     number: '',
//     complement: '',
//     neighborhood: '',
//     city: '',
//     state: '',
//     activeGateway: '',
//     asaasApiKey: '',
//     asaasWebhookSecret: '',
//     lytexClientId: '',
//     lytexClientSecret: '',
//     lytexWebhookSecret: '',
//     autentiqueApiToken: '',
//     teamzapUrl: '',
//     teamzapToken: '',
//     status: 'ACTIVE',
// };

// const INITIAL_INVOICE: InvoiceSettingsData = {
//     invoiceEnabled: false,
//     invoiceDefaultForNew: false,
// };

// // ── Componente principal ───────────────────────────────
// export default function ConfiguracaoEmpresa() {
//     const navigate = useNavigate();
//     const { tier, hasBoletoAccess, hasContratoAccess } = usePlanAccess();

//     const [loading, setLoading] = useState(true);
//     const [saving, setSaving] = useState(false);
//     const [savingNfe, setSavingNfe] = useState(false);
//     const [activeTab, setActiveTab] = useState('geral');
//     const [loadingCep, setLoadingCep] = useState(false);
//     const [formData, setFormData] = useState<CompanyFormData>(INITIAL_FORM);
//     const [invoiceData, setInvoiceData] = useState<InvoiceSettingsData>(INITIAL_INVOICE);
//     const [blockedFeature, setBlockedFeature] = useState<FeatureKey | null>(null);

//     const accessMap: Record<FeatureKey, boolean> = {
//         boleto: hasBoletoAccess,
//         contrato: hasContratoAccess,
//         whatsapp: hasBoletoAccess,
//         nfe: hasBoletoAccess,
//     };

//     const isAllowed = (feature: FeatureKey) => accessMap[feature];

//     const checkAccess = (feature: FeatureKey): boolean => {
//         if (isAllowed(feature)) return true;
//         setBlockedFeature(feature);
//         return false;
//     };

//     useEffect(() => {
//         const fetchAll = async () => {
//             try {
//                 setLoading(true);

//                 const [companyRes, invoiceRes] = await Promise.all([
//                     api.get('/company/settings'),
//                     api.get('/company/invoice-settings').catch(() => ({ data: INITIAL_INVOICE })),
//                 ]);

//                 setFormData(prev => ({
//                     ...prev,
//                     ...companyRes.data,
//                     autentiqueApiToken: companyRes.data.autentiqueApiToken ?? '',
//                 }));

//                 setInvoiceData({
//                     invoiceEnabled: invoiceRes.data.invoiceEnabled ?? false,
//                     invoiceDefaultForNew: invoiceRes.data.invoiceDefaultForNew ?? false,
//                 });
//             } catch {
//                 toast.error('Erro ao carregar dados da empresa.');
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchAll();
//     }, []);

//     const handleChange = (
//         e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
//     ) => {
//         const { name, value } = e.target;

//         setFormData(prev => ({
//             ...prev,
//             [name]: value,
//         }));
//     };

//     const handleGatewaySelect = (gateway: ActiveGateway) => {
//         if ((gateway === 'lytex' || gateway === 'asaas') && !checkAccess('boleto')) {
//             return;
//         }

//         setFormData(prev => ({
//             ...prev,
//             activeGateway: gateway,
//         }));
//     };

//     const buscarCEP = async (cep: string) => {
//         const cepLimpo = cep.replace(/\D/g, '');

//         if (cepLimpo.length !== 8) return;

//         setLoadingCep(true);

//         try {
//             const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
//             const data: ViaCepResponse = await response.json();

//             if (!data.erro) {
//                 setFormData(prev => ({
//                     ...prev,
//                     street: data.logradouro || prev.street,
//                     neighborhood: data.bairro || prev.neighborhood,
//                     city: data.localidade || prev.city,
//                     state: data.uf || prev.state,
//                 }));
//             }
//         } catch {
//             toast.error('Erro ao consultar o CEP.');
//         } finally {
//             setLoadingCep(false);
//         }
//     };

//     const handleCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
//         const { value } = e.target;

//         setFormData(prev => ({
//             ...prev,
//             zipCode: value,
//         }));

//         if (value.replace(/\D/g, '').length === 8) {
//             buscarCEP(value);
//         }
//     };

//     const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
//         e.preventDefault();

//         try {
//             setSaving(true);

//             await api.put('/company/settings', formData);

//             toast.success('Dados salvos com sucesso!');
//         } catch (error: unknown) {
//             const err = error as { response?: { data?: { error?: string } } };

//             toast.error(err.response?.data?.error || 'Erro ao salvar dados.');
//         } finally {
//             setSaving(false);
//         }
//     };

//     const handleSaveInvoiceSettings = async () => {
//         if (!checkAccess('nfe')) return;

//         try {
//             setSavingNfe(true);

//             await api.put('/company/invoice-settings', invoiceData);

//             toast.success('Configurações de Nota Fiscal salvas!');
//         } catch (error: unknown) {
//             const err = error as { response?: { data?: { error?: string } } };

//             toast.error(err.response?.data?.error || 'Erro ao salvar configurações de NF.');
//         } finally {
//             setSavingNfe(false);
//         }
//     };

//     if (loading) {
//         return (
//             <div className="text-center mt-5 pt-5">
//                 <Spinner animation="border" variant="primary" />

//                 <div className="mt-2 text-muted">
//                     Carregando dados da empresa...
//                 </div>
//             </div>
//         );
//     }

//     // ── Sub-componente: Card de gateway ─────────────────
//     const GatewayCard = ({
//         id,
//         value,
//         label,
//         description,
//         isConfigured,
//         featureKey,
//     }: {
//         id: string;
//         value: ActiveGateway;
//         label: string;
//         description: string;
//         isConfigured: boolean;
//         featureKey: FeatureKey;
//     }) => {
//         const isActive = formData.activeGateway === value;
//         const allowed = isAllowed(featureKey);
//         const required = FEATURES[featureKey].requiredPlan;

//         return (
//             <Col md={6}>
//                 <div
//                     onClick={() => handleGatewaySelect(value)}
//                     className={`border rounded-3 p-3 h-100 position-relative ${
//                         isActive
//                             ? 'border-primary bg-primary bg-opacity-10'
//                             : 'border-secondary'
//                     } ${!allowed ? 'opacity-75' : ''}`}
//                     style={{
//                         cursor: 'pointer',
//                         transition: 'all 0.2s',
//                     }}
//                 >
//                     {!allowed && (
//                         <span
//                             className="position-absolute top-0 end-0 m-2 d-flex align-items-center gap-1"
//                             style={{
//                                 backgroundColor: '#fff3cd',
//                                 color: '#664d03',
//                                 border: '1px solid #ffe69c',
//                                 borderRadius: 12,
//                                 padding: '2px 8px',
//                                 fontSize: 11,
//                                 fontWeight: 600,
//                             }}
//                         >
//                             <FaLock size={10} /> {required}
//                         </span>
//                     )}

//                     <div className="d-flex align-items-start gap-2">
//                         <Form.Check
//                             type="radio"
//                             name="activeGateway"
//                             id={id}
//                             value={value}
//                             checked={isActive}
//                             onChange={() => handleGatewaySelect(value)}
//                             className="mt-1"
//                             disabled={!allowed}
//                         />

//                         <div className="flex-grow-1">
//                             <div className="d-flex align-items-center gap-2 flex-wrap">
//                                 <strong>{label}</strong>

//                                 {isActive && (
//                                     <span
//                                         style={{
//                                             backgroundColor: '#0d6efd',
//                                             color: '#fff',
//                                             borderRadius: '0.375rem',
//                                             padding: '2px 10px',
//                                             fontSize: '0.8rem',
//                                             fontWeight: 500,
//                                         }}
//                                     >
//                                         Ativo
//                                     </span>
//                                 )}

//                                 {isConfigured && (
//                                     <span
//                                         style={{
//                                             backgroundColor: '#198754',
//                                             color: '#fff',
//                                             borderRadius: '0.375rem',
//                                             padding: '2px 10px',
//                                             fontSize: '0.8rem',
//                                             fontWeight: 500,
//                                         }}
//                                     >
//                                         ✓ Configurado
//                                     </span>
//                                 )}
//                             </div>

//                             <small className="text-muted">
//                                 {description}
//                             </small>
//                         </div>
//                     </div>
//                 </div>
//             </Col>
//         );
//     };

//     // ── Modal de upgrade ────────────────────────────────
//     const UpgradeModal = () => {
//         if (!blockedFeature) return null;

//         const feature = FEATURES[blockedFeature];
//         const requiredPlan = feature.requiredPlan;
//         const reqColor = PLAN_COLORS[requiredPlan];
//         const curColor = PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC;

//         return (
//             <Modal
//                 show={!!blockedFeature}
//                 onHide={() => setBlockedFeature(null)}
//                 centered
//             >
//                 <Modal.Header closeButton className="border-0 pb-0">
//                     <Modal.Title className="d-flex align-items-center gap-2">
//                         <FaLock className="text-warning" />
//                         Funcionalidade bloqueada
//                     </Modal.Title>
//                 </Modal.Header>

//                 <Modal.Body className="text-center py-4">
//                     <div
//                         className="d-inline-flex align-items-center justify-content-center mb-3"
//                         style={{
//                             width: 72,
//                             height: 72,
//                             borderRadius: '50%',
//                             backgroundColor: `${reqColor}20`,
//                             color: reqColor,
//                             fontSize: 32,
//                         }}
//                     >
//                         {requiredPlan === 'ENTERPRISE' ? <FaCrown /> : <FaRocket />}
//                     </div>

//                     <h5 className="mb-2">
//                         {feature.label}
//                     </h5>

//                     <p className="text-muted mb-3">
//                         {feature.description}
//                     </p>

//                     <div className="alert alert-light border mb-3">
//                         <small className="text-muted d-block mb-1">
//                             Seu plano atual
//                         </small>

//                         <strong style={{ color: curColor }}>
//                             {PLAN_LABELS[tier] ?? tier}
//                         </strong>

//                         <div className="my-2" style={{ fontSize: 20 }}>
//                             ⬇️
//                         </div>

//                         <small className="text-muted d-block mb-1">
//                             Plano necessário
//                         </small>

//                         <strong
//                             style={{
//                                 color: reqColor,
//                                 fontSize: 18,
//                             }}
//                         >
//                             {PLAN_LABELS[requiredPlan] ?? requiredPlan}
//                         </strong>
//                     </div>

//                     <small className="text-muted">
//                         Faça upgrade para desbloquear essa e outras funcionalidades avançadas.
//                     </small>
//                 </Modal.Body>

//                 <Modal.Footer className="border-0 justify-content-center gap-2">
//                     <Button
//                         variant="outline-secondary"
//                         onClick={() => setBlockedFeature(null)}
//                     >
//                         Agora não
//                     </Button>

//                     <Button
//                         variant="primary"
//                         onClick={() => {
//                             setBlockedFeature(null);
//                             navigate('/upgrade');
//                         }}
//                     >
//                         <FaRocket className="me-1" /> Ver planos
//                     </Button>
//                 </Modal.Footer>
//             </Modal>
//         );
//     };

//     return (
//         <Container fluid className="p-4">
//             <UpgradeModal />

//             {/* ── Cabeçalho ─────────────────────────────── */}
//             <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
//                 <div>
//                     <h1 className="mb-0">
//                         Configurações da Empresa
//                     </h1>

//                     <small className="text-muted">
//                         Gerencie os dados da sua empresa no sistema
//                     </small>
//                 </div>

//                 <div className="d-flex align-items-center gap-2 flex-wrap">
//                     <Link
//                         to="/planos"
//                         className="d-inline-flex align-items-center gap-2 text-decoration-none"
//                         style={{
//                             backgroundColor: `${PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC}15`,
//                             border: `1px solid ${PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC}40`,
//                             color: PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC,
//                             borderRadius: 20,
//                             padding: '6px 14px',
//                             fontSize: 13,
//                             fontWeight: 600,
//                             transition: 'all 0.2s',
//                         }}
//                         title="Ver planos disponíveis"
//                     >
//                         {PLAN_ICONS[tier] ?? PLAN_ICONS.BASIC}

//                         <span>
//                             Plano {PLAN_LABELS[tier] ?? tier}
//                         </span>
//                     </Link>

//                     <span
//                         className={`badge bg-${STATUS_COLORS[formData.status] ?? 'secondary'} fs-6 px-3 py-2`}
//                     >
//                         {STATUS_LABELS[formData.status] ?? formData.status}
//                     </span>
//                 </div>
//             </div>

//             <Form onSubmit={handleSubmit}>
//                 <Row>
//                     {/* ── Menu lateral ───────────────────── */}
//                     <Col md={3} className="mb-4">
//                         <Card className="shadow-sm">
//                             <Card.Body className="p-2">
//                                 <Nav className="flex-column gap-1">
//                                     {([
//                                         {
//                                             key: 'geral',
//                                             icon: <FaBuilding className="me-2" />,
//                                             label: 'Dados Gerais',
//                                         },
//                                         {
//                                             key: 'endereco',
//                                             icon: <FaMapMarkerAlt className="me-2" />,
//                                             label: 'Endereço',
//                                         },
//                                         {
//                                             key: 'integracoes',
//                                             icon: <FaPlug className="me-2" />,
//                                             label: 'Integrações',
//                                         },
//                                     ] as const).map(tab => (
//                                         <Nav.Link
//                                             key={tab.key}
//                                             onClick={() => setActiveTab(tab.key)}
//                                             className={`rounded px-3 py-2 d-flex align-items-center ${
//                                                 activeTab === tab.key
//                                                     ? 'bg-primary text-white'
//                                                     : 'text-dark'
//                                             }`}
//                                             style={{ cursor: 'pointer' }}
//                                         >
//                                             {tab.icon} {tab.label}
//                                         </Nav.Link>
//                                     ))}
//                                 </Nav>
//                             </Card.Body>
//                         </Card>
//                     </Col>

//                     {/* ── Conteúdo ───────────────────────── */}
//                     <Col md={9}>
//                         {/* ════════ DADOS GERAIS ════════ */}
//                         {activeTab === 'geral' && (
//                             <Card className="shadow-sm">
//                                 <Card.Header className="bg-white">
//                                     <h5 className="mb-0">
//                                         <FaBuilding className="me-2 text-primary" />
//                                         Dados Gerais
//                                     </h5>
//                                 </Card.Header>

//                                 <Card.Body>
//                                     <Row>
//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Nome Fantasia *
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="name"
//                                                     required
//                                                     value={formData.name}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Razão Social
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="corporateName"
//                                                     value={formData.corporateName}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     CNPJ
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="cnpj"
//                                                     value={formData.cnpj}
//                                                     onChange={handleChange}
//                                                     placeholder="00.000.000/0000-00"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     E-mail *
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="email"
//                                                     name="email"
//                                                     required
//                                                     value={formData.email}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Telefone
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="phone"
//                                                     value={formData.phone}
//                                                     onChange={handleChange}
//                                                     placeholder="(00) 00000-0000"
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>
//                         )}

//                         {/* ════════ ENDEREÇO ════════ */}
//                         {activeTab === 'endereco' && (
//                             <Card className="shadow-sm">
//                                 <Card.Header className="bg-white">
//                                     <h5 className="mb-0">
//                                         <FaMapMarkerAlt className="me-2 text-primary" />
//                                         Endereço

//                                         {loadingCep && (
//                                             <Spinner size="sm" className="ms-2" />
//                                         )}
//                                     </h5>
//                                 </Card.Header>

//                                 <Card.Body>
//                                     <Row>
//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     CEP
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="zipCode"
//                                                     maxLength={9}
//                                                     value={formData.zipCode}
//                                                     onChange={handleCepChange}
//                                                     placeholder="00000-000"
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={2}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     UF
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="state"
//                                                     maxLength={2}
//                                                     value={formData.state}
//                                                     onChange={handleChange}
//                                                     style={{ textTransform: 'uppercase' }}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Cidade
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="city"
//                                                     value={formData.city}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={8}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Rua
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="street"
//                                                     value={formData.street}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={4}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Número
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="number"
//                                                     value={formData.number}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Complemento
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="complement"
//                                                     value={formData.complement}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>

//                                         <Col md={6}>
//                                             <Form.Group className="mb-3">
//                                                 <Form.Label>
//                                                     Bairro
//                                                 </Form.Label>

//                                                 <Form.Control
//                                                     type="text"
//                                                     name="neighborhood"
//                                                     value={formData.neighborhood}
//                                                     onChange={handleChange}
//                                                 />
//                                             </Form.Group>
//                                         </Col>
//                                     </Row>
//                                 </Card.Body>
//                             </Card>
//                         )}

//                         {/* ════════ INTEGRAÇÕES ════════ */}
//                         {activeTab === 'integracoes' && (
//                             <div className="d-flex flex-column gap-3">
//                                 {/* Gateway de pagamento */}
//                                 <Card className="shadow-sm">
//                                     <Card.Header className="bg-white">
//                                         <h5 className="mb-0">
//                                             <FaPlug className="me-2 text-primary" />
//                                             Gateway de Pagamento

//                                             {!hasBoletoAccess && (
//                                                 <span
//                                                     className="ms-2 d-inline-flex align-items-center gap-1"
//                                                     style={{
//                                                         backgroundColor: '#fff3cd',
//                                                         color: '#664d03',
//                                                         border: '1px solid #ffe69c',
//                                                         borderRadius: 12,
//                                                         padding: '2px 10px',
//                                                         fontSize: 11,
//                                                         fontWeight: 600,
//                                                         verticalAlign: 'middle',
//                                                     }}
//                                                 >
//                                                     <FaLock size={10} /> Requer plano PRO
//                                                 </span>
//                                             )}
//                                         </h5>
//                                     </Card.Header>

//                                     <Card.Body>
//                                         <p className="text-muted small mb-3">
//                                             Selecione qual gateway será usado para gerar cobranças
//                                             boleto e PIX. Apenas um pode estar ativo por vez.
//                                         </p>

//                                         <Row className="g-3">
//                                             <GatewayCard
//                                                 id="gateway-lytex"
//                                                 value="lytex"
//                                                 label="Lytex"
//                                                 description="PIX · Boleto · Cartão de Crédito"
//                                                 isConfigured={
//                                                     !!formData.lytexClientId &&
//                                                     !!formData.lytexClientSecret
//                                                 }
//                                                 featureKey="boleto"
//                                             />

//                                             {/* <GatewayCard
//                                                 id="gateway-asaas"
//                                                 value="asaas"
//                                                 label="Asaas"
//                                                 description="PIX · Boleto · Cartão de Crédito"
//                                                 isConfigured={!!formData.asaasApiKey}
//                                                 featureKey="boleto"
//                                             /> */}
//                                         </Row>
//                                     </Card.Body>
//                                 </Card>

//                                 {/* Credenciais Lytex */}
//                                 {formData.activeGateway === 'lytex' && hasBoletoAccess && (
//                                     <Card className="shadow-sm border-primary">
//                                         <Card.Header className="bg-white d-flex align-items-center justify-content-between">
//                                             <h5 className="mb-0">
//                                                 <FaPlug className="me-2 text-primary" />
//                                                 Lytex{' '}
//                                                 <small className="text-muted fw-normal fs-6">
//                                                     — Credenciais
//                                                 </small>
//                                             </h5>

//                                             <span className="badge bg-primary rounded-pill px-3 py-2">
//                                                 Ativo
//                                             </span>
//                                         </Card.Header>

//                                         <Card.Body>
//                                             <Row>
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label>
//                                                             Client ID
//                                                         </Form.Label>

//                                                         <Form.Control
//                                                             type="text"
//                                                             name="lytexClientId"
//                                                             value={formData.lytexClientId}
//                                                             onChange={handleChange}
//                                                             placeholder="Client ID da Lytex"
//                                                             autoComplete="off"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>

//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label>
//                                                             Client Secret
//                                                         </Form.Label>

//                                                         <Form.Control
//                                                             type="password"
//                                                             name="lytexClientSecret"
//                                                             value={formData.lytexClientSecret}
//                                                             onChange={handleChange}
//                                                             placeholder="Client Secret da Lytex"
//                                                             autoComplete="off"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>

//                                                 <Col md={12}>
//                                                     <Form.Group className="mb-0">
//                                                         <Form.Label>
//                                                             Webhook Secret
//                                                         </Form.Label>

//                                                         <Form.Control
//                                                             type="password"
//                                                             name="lytexWebhookSecret"
//                                                             value={formData.lytexWebhookSecret}
//                                                             onChange={handleChange}
//                                                             placeholder="Secret para validar assinatura HMAC"
//                                                             autoComplete="off"
//                                                         />

//                                                         <Form.Text className="text-muted">
//                                                             URL do webhook para cadastrar na Lytex:{' '}

//                                                             <code>
//                                                                 https://erp-maxtramidia-backend.onrender.com/webhooks/lytex/{formData.id}
//                                                             </code>

//                                                             <Button
//                                                                 size="sm"
//                                                                 variant="outline-secondary"
//                                                                 className="ms-2 py-0"
//                                                                 type="button"
//                                                                 onClick={() => {
//                                                                     navigator.clipboard.writeText(
//                                                                         `https://erp-maxtramidia-backend.onrender.com/webhooks/lytex/${formData.id}`
//                                                                     );

//                                                                     toast.success('URL copiada!');
//                                                                 }}
//                                                             >
//                                                                 Copiar
//                                                             </Button>
//                                                         </Form.Text>
//                                                     </Form.Group>
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>
//                                 )}

//                                 {/* Credenciais Asaas */}
//                                 {formData.activeGateway === 'asaas' && hasBoletoAccess && (
//                                     <Card className="shadow-sm border-primary">
//                                         <Card.Header className="bg-white d-flex align-items-center justify-content-between">
//                                             <h5 className="mb-0">
//                                                 <FaPlug className="me-2 text-primary" />
//                                                 Asaas{' '}
//                                                 <small className="text-muted fw-normal fs-6">
//                                                     — Credenciais
//                                                 </small>
//                                             </h5>

//                                             <span className="badge bg-primary rounded-pill px-3 py-2">
//                                                 Ativo
//                                             </span>
//                                         </Card.Header>

//                                         <Card.Body>
//                                             <Row>
//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-3">
//                                                         <Form.Label>
//                                                             API Key
//                                                         </Form.Label>

//                                                         <Form.Control
//                                                             type="password"
//                                                             name="asaasApiKey"
//                                                             value={formData.asaasApiKey}
//                                                             onChange={handleChange}
//                                                             placeholder="$aact_..."
//                                                             autoComplete="off"
//                                                         />
//                                                     </Form.Group>
//                                                 </Col>

//                                                 <Col md={6}>
//                                                     <Form.Group className="mb-0">
//                                                         <Form.Label>
//                                                             Webhook Secret
//                                                         </Form.Label>

//                                                         <Form.Control
//                                                             type="password"
//                                                             name="asaasWebhookSecret"
//                                                             value={formData.asaasWebhookSecret}
//                                                             onChange={handleChange}
//                                                             autoComplete="off"
//                                                         />

//                                                         <Form.Text className="text-muted">
//                                                             URL do webhook:{' '}

//                                                             <code>
//                                                                 {window.location.origin}/api/webhooks/asaas
//                                                             </code>
//                                                         </Form.Text>
//                                                     </Form.Group>
//                                                 </Col>
//                                             </Row>
//                                         </Card.Body>
//                                     </Card>
//                                 )}

//                                 {/* Autentique */}
//                                 <Card
//                                     className={`shadow-sm ${
//                                         hasContratoAccess ? '' : 'opacity-75'
//                                     }`}
//                                 >
//                                     <Card.Header className="bg-white d-flex align-items-center justify-content-between flex-wrap gap-2">
//                                         <h5 className="mb-0">
//                                             <FaFileSignature className="me-2 text-primary" />
//                                             Assinatura Digital de Contratos

//                                             {!hasContratoAccess && (
//                                                 <span
//                                                     className="ms-2 d-inline-flex align-items-center gap-1"
//                                                     style={{
//                                                         backgroundColor: '#fff3cd',
//                                                         color: '#664d03',
//                                                         border: '1px solid #ffe69c',
//                                                         borderRadius: 12,
//                                                         padding: '2px 10px',
//                                                         fontSize: 11,
//                                                         fontWeight: 600,
//                                                         verticalAlign: 'middle',
//                                                     }}
//                                                 >
//                                                     <FaLock size={10} /> Requer plano ENTERPRISE
//                                                 </span>
//                                             )}
//                                         </h5>

//                                         {hasContratoAccess && formData.autentiqueApiToken && (
//                                             <span className="badge bg-success rounded-pill px-3 py-2">
//                                                 ✓ Configurado
//                                             </span>
//                                         )}
//                                     </Card.Header>

//                                     <Card.Body>
//                                         {!hasContratoAccess ? (
//                                             <div className="text-center py-4">
//                                                 <div
//                                                     className="d-inline-flex align-items-center justify-content-center mb-3"
//                                                     style={{
//                                                         width: 72,
//                                                         height: 72,
//                                                         borderRadius: '50%',
//                                                         backgroundColor: `${PLAN_COLORS.ENTERPRISE}20`,
//                                                         color: PLAN_COLORS.ENTERPRISE,
//                                                         fontSize: 32,
//                                                     }}
//                                                 >
//                                                     <FaCrown />
//                                                 </div>

//                                                 <h5 className="mb-2">
//                                                     Assinatura Digital via Autentique
//                                                 </h5>

//                                                 <p className="text-muted mb-3">
//                                                     Envie contratos automaticamente para assinatura
//                                                     digital pela Autentique.
//                                                 </p>

//                                                 <Button
//                                                     type="button"
//                                                     variant="primary"
//                                                     onClick={() => setBlockedFeature('contrato')}
//                                                 >
//                                                     <FaRocket className="me-2" />
//                                                     Ver planos
//                                                 </Button>
//                                             </div>
//                                         ) : (
//                                             <>
//                                                 <p className="text-muted small mb-3">
//                                                     Informe o token da API da Autentique para permitir
//                                                     o envio automático dos contratos gerados pelo sistema.
//                                                 </p>

//                                                 <Row>
//                                                     <Col md={12}>
//                                                         <Form.Group className="mb-3">
//                                                             <Form.Label>
//                                                                 Token da API Autentique
//                                                             </Form.Label>

//                                                             <Form.Control
//                                                                 type="password"
//                                                                 name="autentiqueApiToken"
//                                                                 value={formData.autentiqueApiToken}
//                                                                 onChange={handleChange}
//                                                                 placeholder="Cole aqui o token da API da Autentique"
//                                                                 autoComplete="off"
//                                                             />

//                                                             <Form.Text className="text-muted">
//                                                                 Esse token será usado para criar documentos
//                                                                 e enviar contratos para assinatura digital.
//                                                             </Form.Text>
//                                                             <br/>
//                                                             <Form.Text className="text-muted">
//                                                             URL do webhook para cadastrar na Lytex:{' '}

//                                                             <code>
//                                                                 https://erp-maxtramidia-backend.onrender.com/webhooks/autentique/{formData.id}
//                                                             </code>

//                                                             <Button
//                                                                 size="sm"
//                                                                 variant="outline-secondary"
//                                                                 className="ms-2 py-0"
//                                                                 type="button"
//                                                                 onClick={() => {
//                                                                     navigator.clipboard.writeText(
//                                                                         `https://erp-maxtramidia-backend.onrender.com/webhooks/autentique/${formData.id}`
//                                                                     );

//                                                                     toast.success('URL copiada!');
//                                                                 }}
//                                                             >
//                                                                 Copiar
//                                                             </Button>
//                                                         </Form.Text>
//                                                         </Form.Group>
//                                                     </Col>
//                                                 </Row>

//                                                 <div className="alert alert-info small mb-0">
//                                                     <strong>Como funciona?</strong>

//                                                     <ul className="mb-0 mt-1 ps-3">
//                                                         <li>
//                                                             Cadastre o token da Autentique aqui.
//                                                         </li>

//                                                         <li>
//                                                             No pedido, marque a opção de gerar contrato.
//                                                         </li>

//                                                         <li>
//                                                             Se habilitado, o contrato será enviado para
//                                                             assinatura digital automaticamente.
//                                                         </li>
//                                                     </ul>
//                                                 </div>
//                                             </>
//                                         )}
//                                     </Card.Body>
//                                 </Card>
//                             </div>
//                         )}

//                         {/* ── Botão salvar geral ───────────── */}
//                         <div className="d-flex justify-content-end mt-3">
//                             <Button
//                                 variant="success"
//                                 type="submit"
//                                 disabled={saving}
//                             >
//                                 {saving ? (
//                                     <>
//                                         <Spinner size="sm" className="me-2" />
//                                         Salvando...
//                                     </>
//                                 ) : (
//                                     <>
//                                         <FaSave className="me-2" />
//                                         Salvar Alterações
//                                     </>
//                                 )}
//                             </Button>
//                         </div>
//                     </Col>
//                 </Row>
//             </Form>
//         </Container>
//     );
// }

//1206


import React, { useState, useEffect, useContext } from 'react';
import {
    Container,
    Card,
    Button,
    Form,
    Row,
    Col,
    Spinner,
    Nav,
    Modal,
} from 'react-bootstrap';
import {
    FaSave,
    FaBuilding,
    FaMapMarkerAlt,
    FaPlug,
    FaLock,
    FaCrown,
    FaRocket,
    FaFileSignature,
} from 'react-icons/fa';
import { toast } from 'react-toastify';
import { Link, useNavigate } from 'react-router-dom';
import api from '../../services/api';
import { usePlanAccess } from '../../hooks/usePlanAccess';
import { AuthContext } from '../../contexts/AuthContext';

// ── Tipos ──────────────────────────────────────────────
type CompanyStatus = 'ACTIVE' | 'SUSPENDED' | 'CANCELED';
type ActiveGateway = 'lytex' | 'asaas' | '';
type FeatureKey = 'boleto' | 'contrato' | 'whatsapp' | 'nfe';

interface CompanyFormData {
    id: string;
    name: string;
    corporateName: string;
    cnpj: string;
    email: string;
    phone: string;
    municipalRegistration: string;
    stateRegistration: string;
    taxRegime: string;
    zipCode: string;
    street: string;
    number: string;
    complement: string;
    neighborhood: string;
    city: string;
    state: string;
    activeGateway: ActiveGateway;
    asaasApiKey: string;
    asaasWebhookSecret: string;
    lytexClientId: string;
    lytexClientSecret: string;
    lytexWebhookSecret: string;
    autentiqueApiToken: string;
    teamzapUrl: string;
    teamzapToken: string;
    status: CompanyStatus;
}

interface InvoiceSettingsData {
    invoiceEnabled: boolean;
    invoiceDefaultForNew: boolean;
}

interface ViaCepResponse {
    logradouro: string;
    bairro: string;
    localidade: string;
    uf: string;
    erro?: boolean;
}

// ── Constantes ─────────────────────────────────────────
const STATUS_COLORS: Record<CompanyStatus, string> = {
    ACTIVE: 'success',
    SUSPENDED: 'warning',
    CANCELED: 'danger',
};

const STATUS_LABELS: Record<CompanyStatus, string> = {
    ACTIVE: 'Ativa',
    SUSPENDED: 'Suspensa',
    CANCELED: 'Cancelada',
};

const PLAN_LABELS: Record<string, string> = {
    BASIC: 'Básico',
    PRO: 'Profissional',
    ENTERPRISE: 'Empresarial',
};

const PLAN_COLORS: Record<string, string> = {
    BASIC: '#6c757d',
    PRO: '#4361ee',
    ENTERPRISE: '#f8961e',
};

const PLAN_ICONS: Record<string, React.ReactNode> = {
    BASIC: <FaLock size={12} />,
    PRO: <FaRocket size={12} />,
    ENTERPRISE: <FaCrown size={12} />,
};

const FEATURES: Record<FeatureKey, { label: string; description: string; requiredPlan: string }> = {
    boleto: {
        label: 'Gateway de Pagamento',
        description: 'Gere cobranças via PIX, Boleto e Cartão automaticamente.',
        requiredPlan: 'PRO',
    },
    contrato: {
        label: 'Assinatura Digital de Contratos',
        description: 'Envie contratos para assinatura digital via Autentique.',
        requiredPlan: 'ENTERPRISE',
    },
    whatsapp: {
        label: 'Notificações WhatsApp',
        description: 'Dispare mensagens automáticas de cobrança via WhatsApp.',
        requiredPlan: 'PRO',
    },
    nfe: {
        label: 'Emissão de Notas Fiscais',
        description: 'Emita NFS-e automaticamente após o pagamento das parcelas.',
        requiredPlan: 'PRO',
    },
};

const INITIAL_FORM: CompanyFormData = {
    id: '',
    name: '',
    corporateName: '',
    cnpj: '',
    email: '',
    phone: '',
    municipalRegistration: '',
    stateRegistration: '',
    taxRegime: '',
    zipCode: '',
    street: '',
    number: '',
    complement: '',
    neighborhood: '',
    city: '',
    state: '',
    activeGateway: '',
    asaasApiKey: '',
    asaasWebhookSecret: '',
    lytexClientId: '',
    lytexClientSecret: '',
    lytexWebhookSecret: '',
    autentiqueApiToken: '',
    teamzapUrl: '',
    teamzapToken: '',
    status: 'ACTIVE',
};

const INITIAL_INVOICE: InvoiceSettingsData = {
    invoiceEnabled: false,
    invoiceDefaultForNew: false,
};

// ── Componente principal ───────────────────────────────
export default function ConfiguracaoEmpresa() {
    const navigate = useNavigate();
    const { tier, hasBoletoAccess, hasContratoAccess } = usePlanAccess();
    const { companyLogo, loadCompanyLogo } = useContext(AuthContext);


    const [loading, setLoading] = useState(true);
    const [saving, setSaving] = useState(false);
    const [savingNfe, setSavingNfe] = useState(false);
    const [activeTab, setActiveTab] = useState('geral');
    const [loadingCep, setLoadingCep] = useState(false);
    const [formData, setFormData] = useState<CompanyFormData>(INITIAL_FORM);
    const [invoiceData, setInvoiceData] = useState<InvoiceSettingsData>(INITIAL_INVOICE);
    const [blockedFeature, setBlockedFeature] = useState<FeatureKey | null>(null);

    // ── Logo ────────────────────────────────────────────
    const [logoPreview, setLogoPreview] = useState<string | null>(null);
    const [logoFile, setLogoFile] = useState<File | null>(null);
    const [uploadingLogo, setUploadingLogo] = useState(false);

    const accessMap: Record<FeatureKey, boolean> = {
        boleto: hasBoletoAccess,
        contrato: hasContratoAccess,
        whatsapp: hasBoletoAccess,
        nfe: hasBoletoAccess,
    };

    const isAllowed = (feature: FeatureKey) => accessMap[feature];

    const checkAccess = (feature: FeatureKey): boolean => {
        if (isAllowed(feature)) return true;
        setBlockedFeature(feature);
        return false;
    };

    useEffect(() => {
        const fetchAll = async () => {
            try {
                setLoading(true);

                const [companyRes, invoiceRes] = await Promise.all([
                    api.get('/company/settings'),
                    api.get('/company/invoice-settings').catch(() => ({ data: INITIAL_INVOICE })),
                ]);

                setFormData(prev => ({
                    ...prev,
                    ...companyRes.data,
                    autentiqueApiToken: companyRes.data.autentiqueApiToken ?? '',
                }));

                setInvoiceData({
                    invoiceEnabled: invoiceRes.data.invoiceEnabled ?? false,
                    invoiceDefaultForNew: invoiceRes.data.invoiceDefaultForNew ?? false,
                });
            } catch {
                toast.error('Erro ao carregar dados da empresa.');
            } finally {
                setLoading(false);
            }
        };

        fetchAll();
    }, []);

    const handleChange = (
        e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>
    ) => {
        const { name, value } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleGatewaySelect = (gateway: ActiveGateway) => {
        if ((gateway === 'lytex' || gateway === 'asaas') && !checkAccess('boleto')) {
            return;
        }

        setFormData(prev => ({
            ...prev,
            activeGateway: gateway,
        }));
    };

    const buscarCEP = async (cep: string) => {
        const cepLimpo = cep.replace(/\D/g, '');

        if (cepLimpo.length !== 8) return;

        setLoadingCep(true);

        try {
            const response = await fetch(`https://viacep.com.br/ws/${cepLimpo}/json/`);
            const data: ViaCepResponse = await response.json();

            if (!data.erro) {
                setFormData(prev => ({
                    ...prev,
                    street: data.logradouro || prev.street,
                    neighborhood: data.bairro || prev.neighborhood,
                    city: data.localidade || prev.city,
                    state: data.uf || prev.state,
                }));
            }
        } catch {
            toast.error('Erro ao consultar o CEP.');
        } finally {
            setLoadingCep(false);
        }
    };

    const handleCepChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { value } = e.target;

        setFormData(prev => ({
            ...prev,
            zipCode: value,
        }));

        if (value.replace(/\D/g, '').length === 8) {
            buscarCEP(value);
        }
    };

    // ── Logo: seleção e upload ──────────────────────────
    const handleLogoSelect = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0];
        if (!file) return;

        if (file.size > 2 * 1024 * 1024) {
            toast.error('A logo deve ter no máximo 2MB.');
            return;
        }

        setLogoFile(file);
        setLogoPreview(URL.createObjectURL(file));
    };

    const handleLogoUpload = async () => {
        if (!logoFile) return;
        setUploadingLogo(true);

        try {
            const data = new FormData();
            data.append('file', logoFile);   // ✅ agora bate com upload.single("file")

            // ✅ Sem header manual — deixe o axios montar o boundary
            await api.post('/company/logo', data);

            await loadCompanyLogo(); // atualiza a logo na sidebar sem refresh
            setLogoFile(null);
            setLogoPreview(null);
            toast.success('Logo atualizada com sucesso!');
        } catch (error: unknown) {
            const err = error as { response?: { data?: { error?: string } } };
            toast.error(err.response?.data?.error || 'Erro ao enviar a logo.');
        } finally {
            setUploadingLogo(false);
        }
    };

    const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();

        try {
            setSaving(true);

            await api.put('/company/settings', formData);

            toast.success('Dados salvos com sucesso!');
        } catch (error: unknown) {
            const err = error as { response?: { data?: { error?: string } } };

            toast.error(err.response?.data?.error || 'Erro ao salvar dados.');
        } finally {
            setSaving(false);
        }
    };

    const handleSaveInvoiceSettings = async () => {
        if (!checkAccess('nfe')) return;

        try {
            setSavingNfe(true);

            await api.put('/company/invoice-settings', invoiceData);

            toast.success('Configurações de Nota Fiscal salvas!');
        } catch (error: unknown) {
            const err = error as { response?: { data?: { error?: string } } };

            toast.error(err.response?.data?.error || 'Erro ao salvar configurações de NF.');
        } finally {
            setSavingNfe(false);
        }
    };

    if (loading) {
        return (
            <div className="text-center mt-5 pt-5">
                <Spinner animation="border" variant="primary" />

                <div className="mt-2 text-muted">
                    Carregando dados da empresa...
                </div>
            </div>
        );
    }

    // ── Sub-componente: Card de gateway ─────────────────
    const GatewayCard = ({
        id,
        value,
        label,
        description,
        isConfigured,
        featureKey,
    }: {
        id: string;
        value: ActiveGateway;
        label: string;
        description: string;
        isConfigured: boolean;
        featureKey: FeatureKey;
    }) => {
        const isActive = formData.activeGateway === value;
        const allowed = isAllowed(featureKey);
        const required = FEATURES[featureKey].requiredPlan;

        return (
            <Col md={6}>
                <div
                    onClick={() => handleGatewaySelect(value)}
                    className={`border rounded-3 p-3 h-100 position-relative ${
                        isActive
                            ? 'border-primary bg-primary bg-opacity-10'
                            : 'border-secondary'
                    } ${!allowed ? 'opacity-75' : ''}`}
                    style={{
                        cursor: 'pointer',
                        transition: 'all 0.2s',
                    }}
                >
                    {!allowed && (
                        <span
                            className="position-absolute top-0 end-0 m-2 d-flex align-items-center gap-1"
                            style={{
                                backgroundColor: '#fff3cd',
                                color: '#664d03',
                                border: '1px solid #ffe69c',
                                borderRadius: 12,
                                padding: '2px 8px',
                                fontSize: 11,
                                fontWeight: 600,
                            }}
                        >
                            <FaLock size={10} /> {required}
                        </span>
                    )}

                    <div className="d-flex align-items-start gap-2">
                        <Form.Check
                            type="radio"
                            name="activeGateway"
                            id={id}
                            value={value}
                            checked={isActive}
                            onChange={() => handleGatewaySelect(value)}
                            className="mt-1"
                            disabled={!allowed}
                        />

                        <div className="flex-grow-1">
                            <div className="d-flex align-items-center gap-2 flex-wrap">
                                <strong>{label}</strong>

                                {isActive && (
                                    <span
                                        style={{
                                            backgroundColor: '#0d6efd',
                                            color: '#fff',
                                            borderRadius: '0.375rem',
                                            padding: '2px 10px',
                                            fontSize: '0.8rem',
                                            fontWeight: 500,
                                        }}
                                    >
                                        Ativo
                                    </span>
                                )}

                                {isConfigured && (
                                    <span
                                        style={{
                                            backgroundColor: '#198754',
                                            color: '#fff',
                                            borderRadius: '0.375rem',
                                            padding: '2px 10px',
                                            fontSize: '0.8rem',
                                            fontWeight: 500,
                                        }}
                                    >
                                        ✓ Configurado
                                    </span>
                                )}
                            </div>

                            <small className="text-muted">
                                {description}
                            </small>
                        </div>
                    </div>
                </div>
            </Col>
        );
    };

    // ── Modal de upgrade ────────────────────────────────
    const UpgradeModal = () => {
        if (!blockedFeature) return null;

        const feature = FEATURES[blockedFeature];
        const requiredPlan = feature.requiredPlan;
        const reqColor = PLAN_COLORS[requiredPlan];
        const curColor = PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC;

        return (
            <Modal
                show={!!blockedFeature}
                onHide={() => setBlockedFeature(null)}
                centered
            >
                <Modal.Header closeButton className="border-0 pb-0">
                    <Modal.Title className="d-flex align-items-center gap-2">
                        <FaLock className="text-warning" />
                        Funcionalidade bloqueada
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body className="text-center py-4">
                    <div
                        className="d-inline-flex align-items-center justify-content-center mb-3"
                        style={{
                            width: 72,
                            height: 72,
                            borderRadius: '50%',
                            backgroundColor: `${reqColor}20`,
                            color: reqColor,
                            fontSize: 32,
                        }}
                    >
                        {requiredPlan === 'ENTERPRISE' ? <FaCrown /> : <FaRocket />}
                    </div>

                    <h5 className="mb-2">
                        {feature.label}
                    </h5>

                    <p className="text-muted mb-3">
                        {feature.description}
                    </p>

                    <div className="alert alert-light border mb-3">
                        <small className="text-muted d-block mb-1">
                            Seu plano atual
                        </small>

                        <strong style={{ color: curColor }}>
                            {PLAN_LABELS[tier] ?? tier}
                        </strong>

                        <div className="my-2" style={{ fontSize: 20 }}>
                            ⬇️
                        </div>

                        <small className="text-muted d-block mb-1">
                            Plano necessário
                        </small>

                        <strong
                            style={{
                                color: reqColor,
                                fontSize: 18,
                            }}
                        >
                            {PLAN_LABELS[requiredPlan] ?? requiredPlan}
                        </strong>
                    </div>

                    <small className="text-muted">
                        Faça upgrade para desbloquear essa e outras funcionalidades avançadas.
                    </small>
                </Modal.Body>

                <Modal.Footer className="border-0 justify-content-center gap-2">
                    <Button
                        variant="outline-secondary"
                        onClick={() => setBlockedFeature(null)}
                    >
                        Agora não
                    </Button>

                    <Button
                        variant="primary"
                        onClick={() => {
                            setBlockedFeature(null);
                            navigate('/upgrade');
                        }}
                    >
                        <FaRocket className="me-1" /> Ver planos
                    </Button>
                </Modal.Footer>
            </Modal>
        );
    };

    return (
        <Container fluid className="p-4">
            <UpgradeModal />

            {/* ── Cabeçalho ─────────────────────────────── */}
            <div className="d-flex justify-content-between align-items-center mb-4 flex-wrap gap-2">
                <div>
                    <h1 className="mb-0">
                        Configurações da Empresa
                    </h1>

                    <small className="text-muted">
                        Gerencie os dados da sua empresa no sistema
                    </small>
                </div>

                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <Link
                        to="/planos"
                        className="d-inline-flex align-items-center gap-2 text-decoration-none"
                        style={{
                            backgroundColor: `${PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC}15`,
                            border: `1px solid ${PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC}40`,
                            color: PLAN_COLORS[tier] ?? PLAN_COLORS.BASIC,
                            borderRadius: 20,
                            padding: '6px 14px',
                            fontSize: 13,
                            fontWeight: 600,
                            transition: 'all 0.2s',
                        }}
                        title="Ver planos disponíveis"
                    >
                        {PLAN_ICONS[tier] ?? PLAN_ICONS.BASIC}

                        <span>
                            Plano {PLAN_LABELS[tier] ?? tier}
                        </span>
                    </Link>

                    <span
                        className={`badge bg-${STATUS_COLORS[formData.status] ?? 'secondary'} fs-6 px-3 py-2`}
                    >
                        {STATUS_LABELS[formData.status] ?? formData.status}
                    </span>
                </div>
            </div>

            <Form onSubmit={handleSubmit}>
                <Row>
                    {/* ── Menu lateral ───────────────────── */}
                    <Col md={3} className="mb-4">
                        <Card className="shadow-sm">
                            <Card.Body className="p-2">
                                <Nav className="flex-column gap-1">
                                    {([
                                        {
                                            key: 'geral',
                                            icon: <FaBuilding className="me-2" />,
                                            label: 'Dados Gerais',
                                        },
                                        {
                                            key: 'endereco',
                                            icon: <FaMapMarkerAlt className="me-2" />,
                                            label: 'Endereço',
                                        },
                                        {
                                            key: 'integracoes',
                                            icon: <FaPlug className="me-2" />,
                                            label: 'Integrações',
                                        },
                                    ] as const).map(tab => (
                                        <Nav.Link
                                            key={tab.key}
                                            onClick={() => setActiveTab(tab.key)}
                                            className={`rounded px-3 py-2 d-flex align-items-center ${
                                                activeTab === tab.key
                                                    ? 'bg-primary text-white'
                                                    : 'text-dark'
                                            }`}
                                            style={{ cursor: 'pointer' }}
                                        >
                                            {tab.icon} {tab.label}
                                        </Nav.Link>
                                    ))}
                                </Nav>
                            </Card.Body>
                        </Card>
                    </Col>

                    {/* ── Conteúdo ───────────────────────── */}
                    <Col md={9}>
                        {/* ════════ DADOS GERAIS ════════ */}
                        {activeTab === 'geral' && (
                            <Card className="shadow-sm">
                                <Card.Header className="bg-white">
                                    <h5 className="mb-0">
                                        <FaBuilding className="me-2 text-primary" />
                                        Dados Gerais
                                    </h5>
                                </Card.Header>

                                <Card.Body>
                                    {/* ── Logo da empresa ── */}
                                    <Row className="mb-4">
                                        <Col md={12}>
                                            <div className="d-flex align-items-center gap-4 flex-wrap p-3 border rounded-3 bg-light">
                                                <div
                                                    className="d-flex align-items-center justify-content-center bg-white border rounded-3"
                                                    style={{ width: 120, height: 120, overflow: 'hidden' }}
                                                >
                                                    <img
                                                        src={logoPreview || companyLogo || '/placeholder-logo.png'}
                                                        alt="Logo da empresa"
                                                        style={{
                                                            maxWidth: '100%',
                                                            maxHeight: '100%',
                                                            objectFit: 'contain',
                                                        }}
                                                    />
                                                </div>

                                                <div className="flex-grow-1">
                                                    <Form.Label className="fw-semibold mb-1">
                                                        Logo da Empresa
                                                    </Form.Label>

                                                    <p className="text-muted small mb-2">
                                                        PNG, JPG ou SVG · máx. 2MB · proporção recomendada 4:1
                                                    </p>

                                                    <div className="d-flex align-items-center gap-2 flex-wrap">
                                                        <Form.Control
                                                            type="file"
                                                            accept="image/*"
                                                            size="sm"
                                                            style={{ maxWidth: 280 }}
                                                            onChange={handleLogoSelect}
                                                        />

                                                        <Button
                                                            type="button"
                                                            variant="primary"
                                                            size="sm"
                                                            disabled={!logoFile || uploadingLogo}
                                                            onClick={handleLogoUpload}
                                                        >
                                                            {uploadingLogo ? (
                                                                <>
                                                                    <Spinner size="sm" className="me-2" />
                                                                    Enviando...
                                                                </>
                                                            ) : (
                                                                <>
                                                                    <FaSave className="me-2" />
                                                                    Salvar Logo
                                                                </>
                                                            )}
                                                        </Button>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>

                                    <hr className="mb-4" />

                                    <Row>
                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Nome Fantasia *
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="name"
                                                    required
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Razão Social
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="corporateName"
                                                    value={formData.corporateName}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    CNPJ
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="cnpj"
                                                    value={formData.cnpj}
                                                    onChange={handleChange}
                                                    placeholder="00.000.000/0000-00"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    E-mail *
                                                </Form.Label>

                                                <Form.Control
                                                    type="email"
                                                    name="email"
                                                    required
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Telefone
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                    placeholder="(00) 00000-0000"
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}

                        {/* ════════ ENDEREÇO ════════ */}
                        {activeTab === 'endereco' && (
                            <Card className="shadow-sm">
                                <Card.Header className="bg-white">
                                    <h5 className="mb-0">
                                        <FaMapMarkerAlt className="me-2 text-primary" />
                                        Endereço

                                        {loadingCep && (
                                            <Spinner size="sm" className="ms-2" />
                                        )}
                                    </h5>
                                </Card.Header>

                                <Card.Body>
                                    <Row>
                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    CEP
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="zipCode"
                                                    maxLength={9}
                                                    value={formData.zipCode}
                                                    onChange={handleCepChange}
                                                    placeholder="00000-000"
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={2}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    UF
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="state"
                                                    maxLength={2}
                                                    value={formData.state}
                                                    onChange={handleChange}
                                                    style={{ textTransform: 'uppercase' }}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Cidade
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={8}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Rua
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="street"
                                                    value={formData.street}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={4}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Número
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="number"
                                                    value={formData.number}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Complemento
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="complement"
                                                    value={formData.complement}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>

                                        <Col md={6}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>
                                                    Bairro
                                                </Form.Label>

                                                <Form.Control
                                                    type="text"
                                                    name="neighborhood"
                                                    value={formData.neighborhood}
                                                    onChange={handleChange}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                        )}

                        {/* ════════ INTEGRAÇÕES ════════ */}
                        {activeTab === 'integracoes' && (
                            <div className="d-flex flex-column gap-3">
                                {/* Gateway de pagamento */}
                                <Card className="shadow-sm">
                                    <Card.Header className="bg-white">
                                        <h5 className="mb-0">
                                            <FaPlug className="me-2 text-primary" />
                                            Gateway de Pagamento

                                            {!hasBoletoAccess && (
                                                <span
                                                    className="ms-2 d-inline-flex align-items-center gap-1"
                                                    style={{
                                                        backgroundColor: '#fff3cd',
                                                        color: '#664d03',
                                                        border: '1px solid #ffe69c',
                                                        borderRadius: 12,
                                                        padding: '2px 10px',
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                        verticalAlign: 'middle',
                                                    }}
                                                >
                                                    <FaLock size={10} /> Requer plano PRO
                                                </span>
                                            )}
                                        </h5>
                                    </Card.Header>

                                    <Card.Body>
                                        <p className="text-muted small mb-3">
                                            Selecione qual gateway será usado para gerar cobranças
                                            boleto e PIX. Apenas um pode estar ativo por vez.
                                        </p>

                                        <Row className="g-3">
                                            <GatewayCard
                                                id="gateway-lytex"
                                                value="lytex"
                                                label="Lytex"
                                                description="PIX · Boleto · Cartão de Crédito"
                                                isConfigured={
                                                    !!formData.lytexClientId &&
                                                    !!formData.lytexClientSecret
                                                }
                                                featureKey="boleto"
                                            />

                                            {/* <GatewayCard
                                                id="gateway-asaas"
                                                value="asaas"
                                                label="Asaas"
                                                description="PIX · Boleto · Cartão de Crédito"
                                                isConfigured={!!formData.asaasApiKey}
                                                featureKey="boleto"
                                            /> */}
                                        </Row>
                                    </Card.Body>
                                </Card>

                                {/* Credenciais Lytex */}
                                {formData.activeGateway === 'lytex' && hasBoletoAccess && (
                                    <Card className="shadow-sm border-primary">
                                        <Card.Header className="bg-white d-flex align-items-center justify-content-between">
                                            <h5 className="mb-0">
                                                <FaPlug className="me-2 text-primary" />
                                                Lytex{' '}
                                                <small className="text-muted fw-normal fs-6">
                                                    — Credenciais
                                                </small>
                                            </h5>

                                            <span className="badge bg-primary rounded-pill px-3 py-2">
                                                Ativo
                                            </span>
                                        </Card.Header>

                                        <Card.Body>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Client ID
                                                        </Form.Label>

                                                        <Form.Control
                                                            type="text"
                                                            name="lytexClientId"
                                                            value={formData.lytexClientId}
                                                            onChange={handleChange}
                                                            placeholder="Client ID da Lytex"
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            Client Secret
                                                        </Form.Label>

                                                        <Form.Control
                                                            type="password"
                                                            name="lytexClientSecret"
                                                            value={formData.lytexClientSecret}
                                                            onChange={handleChange}
                                                            placeholder="Client Secret da Lytex"
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={12}>
                                                    <Form.Group className="mb-0">
                                                        <Form.Label>
                                                            Webhook Secret
                                                        </Form.Label>

                                                        <Form.Control
                                                            type="password"
                                                            name="lytexWebhookSecret"
                                                            value={formData.lytexWebhookSecret}
                                                            onChange={handleChange}
                                                            placeholder="Secret para validar assinatura HMAC"
                                                            autoComplete="off"
                                                        />

                                                        <Form.Text className="text-muted">
                                                            URL do webhook para cadastrar na Lytex:{' '}

                                                            <code>
                                                                https://erp-maxtramidia-backend.onrender.com/webhooks/lytex/{formData.id}
                                                            </code>

                                                            <Button
                                                                size="sm"
                                                                variant="outline-secondary"
                                                                className="ms-2 py-0"
                                                                type="button"
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        `https://erp-maxtramidia-backend.onrender.com/webhooks/lytex/${formData.id}`
                                                                    );

                                                                    toast.success('URL copiada!');
                                                                }}
                                                            >
                                                                Copiar
                                                            </Button>
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )}

                                {/* Credenciais Asaas */}
                                {formData.activeGateway === 'asaas' && hasBoletoAccess && (
                                    <Card className="shadow-sm border-primary">
                                        <Card.Header className="bg-white d-flex align-items-center justify-content-between">
                                            <h5 className="mb-0">
                                                <FaPlug className="me-2 text-primary" />
                                                Asaas{' '}
                                                <small className="text-muted fw-normal fs-6">
                                                    — Credenciais
                                                </small>
                                            </h5>

                                            <span className="badge bg-primary rounded-pill px-3 py-2">
                                                Ativo
                                            </span>
                                        </Card.Header>

                                        <Card.Body>
                                            <Row>
                                                <Col md={6}>
                                                    <Form.Group className="mb-3">
                                                        <Form.Label>
                                                            API Key
                                                        </Form.Label>

                                                        <Form.Control
                                                            type="password"
                                                            name="asaasApiKey"
                                                            value={formData.asaasApiKey}
                                                            onChange={handleChange}
                                                            placeholder="$aact_..."
                                                            autoComplete="off"
                                                        />
                                                    </Form.Group>
                                                </Col>

                                                <Col md={6}>
                                                    <Form.Group className="mb-0">
                                                        <Form.Label>
                                                            Webhook Secret
                                                        </Form.Label>

                                                        <Form.Control
                                                            type="password"
                                                            name="asaasWebhookSecret"
                                                            value={formData.asaasWebhookSecret}
                                                            onChange={handleChange}
                                                            autoComplete="off"
                                                        />

                                                        <Form.Text className="text-muted">
                                                            URL do webhook:{' '}

                                                            <code>
                                                                {window.location.origin}/api/webhooks/asaas
                                                            </code>
                                                        </Form.Text>
                                                    </Form.Group>
                                                </Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                )}

                                {/* Autentique */}
                                <Card
                                    className={`shadow-sm ${
                                        hasContratoAccess ? '' : 'opacity-75'
                                    }`}
                                >
                                    <Card.Header className="bg-white d-flex align-items-center justify-content-between flex-wrap gap-2">
                                        <h5 className="mb-0">
                                            <FaFileSignature className="me-2 text-primary" />
                                            Assinatura Digital de Contratos

                                            {!hasContratoAccess && (
                                                <span
                                                    className="ms-2 d-inline-flex align-items-center gap-1"
                                                    style={{
                                                        backgroundColor: '#fff3cd',
                                                        color: '#664d03',
                                                        border: '1px solid #ffe69c',
                                                        borderRadius: 12,
                                                        padding: '2px 10px',
                                                        fontSize: 11,
                                                        fontWeight: 600,
                                                        verticalAlign: 'middle',
                                                    }}
                                                >
                                                    <FaLock size={10} /> Requer plano ENTERPRISE
                                                </span>
                                            )}
                                        </h5>

                                        {hasContratoAccess && formData.autentiqueApiToken && (
                                            <span className="badge bg-success rounded-pill px-3 py-2">
                                                ✓ Configurado
                                            </span>
                                        )}
                                    </Card.Header>

                                    <Card.Body>
                                        {!hasContratoAccess ? (
                                            <div className="text-center py-4">
                                                <div
                                                    className="d-inline-flex align-items-center justify-content-center mb-3"
                                                    style={{
                                                        width: 72,
                                                        height: 72,
                                                        borderRadius: '50%',
                                                        backgroundColor: `${PLAN_COLORS.ENTERPRISE}20`,
                                                        color: PLAN_COLORS.ENTERPRISE,
                                                        fontSize: 32,
                                                    }}
                                                >
                                                    <FaCrown />
                                                </div>

                                                <h5 className="mb-2">
                                                    Assinatura Digital via Autentique
                                                </h5>

                                                <p className="text-muted mb-3">
                                                    Envie contratos automaticamente para assinatura
                                                    digital pela Autentique.
                                                </p>

                                                <Button
                                                    type="button"
                                                    variant="primary"
                                                    onClick={() => setBlockedFeature('contrato')}
                                                >
                                                    <FaRocket className="me-2" />
                                                    Ver planos
                                                </Button>
                                            </div>
                                        ) : (
                                            <>
                                                <p className="text-muted small mb-3">
                                                    Informe o token da API da Autentique para permitir
                                                    o envio automático dos contratos gerados pelo sistema.
                                                </p>

                                                <Row>
                                                    <Col md={12}>
                                                        <Form.Group className="mb-3">
                                                            <Form.Label>
                                                                Token da API Autentique
                                                            </Form.Label>

                                                            <Form.Control
                                                                type="password"
                                                                name="autentiqueApiToken"
                                                                value={formData.autentiqueApiToken}
                                                                onChange={handleChange}
                                                                placeholder="Cole aqui o token da API da Autentique"
                                                                autoComplete="off"
                                                            />

                                                            <Form.Text className="text-muted">
                                                                Esse token será usado para criar documentos
                                                                e enviar contratos para assinatura digital.
                                                            </Form.Text>
                                                            <br/>
                                                            <Form.Text className="text-muted">
                                                            URL do webhook para cadastrar na Autentique:{' '}

                                                            <code>
                                                                https://erp-maxtramidia-backend.onrender.com/webhooks/autentique/{formData.id}
                                                            </code>

                                                            <Button
                                                                size="sm"
                                                                variant="outline-secondary"
                                                                className="ms-2 py-0"
                                                                type="button"
                                                                onClick={() => {
                                                                    navigator.clipboard.writeText(
                                                                        `https://erp-maxtramidia-backend.onrender.com/webhooks/autentique/${formData.id}`
                                                                    );

                                                                    toast.success('URL copiada!');
                                                                }}
                                                            >
                                                                Copiar
                                                            </Button>
                                                        </Form.Text>
                                                        </Form.Group>
                                                    </Col>
                                                </Row>

                                                <div className="alert alert-info small mb-0">
                                                    <strong>Como funciona?</strong>

                                                    <ul className="mb-0 mt-1 ps-3">
                                                        <li>
                                                            Cadastre o token da Autentique aqui.
                                                        </li>

                                                        <li>
                                                            No pedido, marque a opção de gerar contrato.
                                                        </li>

                                                        <li>
                                                            Se habilitado, o contrato será enviado para
                                                            assinatura digital automaticamente.
                                                        </li>
                                                    </ul>
                                                </div>
                                            </>
                                        )}
                                    </Card.Body>
                                </Card>
                            </div>
                        )}

                        {/* ── Botão salvar geral ───────────── */}
                        <div className="d-flex justify-content-end mt-3">
                            <Button
                                variant="success"
                                type="submit"
                                disabled={saving}
                            >
                                {saving ? (
                                    <>
                                        <Spinner size="sm" className="me-2" />
                                        Salvando...
                                    </>
                                ) : (
                                    <>
                                        <FaSave className="me-2" />
                                        Salvar Alterações
                                    </>
                                )}
                            </Button>
                        </div>
                    </Col>
                </Row>
            </Form>
        </Container>
    );
}
